var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.showcases),function(showcase){return _c('ShowcaseRow',{key:showcase.id,attrs:{"showcase":showcase}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }